import { cn, getTierClasses } from './listingCardUtils.js';

function normalizeBadge(value) {
  return String(value || '').trim().toLowerCase().replace(/[_\s-]+/g, ' ');
}

export default function ListingCardBadges({ listing, show = {}, tier = 'basic', variant = 'content', claimed = false }) {
  if (!show.badges) return null;

  const tierClasses = getTierClasses(tier);
  const badges = [
    ...listing.badges.filter((badge) => {
      const normalizedBadge = normalizeBadge(badge);
      return normalizedBadge !== 'active' && normalizedBadge !== 'claimed';
    }),
    claimed && listing.isClaimed ? 'Claimed' : null,
  ].filter(Boolean);

  if (badges.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {badges.slice(0, 4).map((badge) => (
        <span
          key={badge}
          className={cn(
            'inline-flex rounded-full border px-2 py-0.5 text-[11px] font-medium',
            variant === 'hero' ? 'border-white/25 bg-white/15 text-white' : tierClasses.badge,
          )}
        >
          {badge}
        </span>
      ))}
    </div>
  );
}
